"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = getMetadata;
exports.isChildCategoryInfo = void 0;

var isChildCategoryInfo = function isChildCategoryInfo(category) {
  return 'topicCount' in category || 'subforums' in category;
};

exports.isChildCategoryInfo = isChildCategoryInfo;

function getMetadata(categories, visibleTopicsCount) {
  var categoriesCount = Array.isArray(categories) ? categories.length : 0;

  if (!Array.isArray(categories) && !isChildCategoryInfo(categories)) {
    categoriesCount = categories.children.length;
  }

  var totalTopicCount = visibleTopicsCount;
  return {
    totalTopicCount: totalTopicCount,
    categoriesCount: categoriesCount
  };
}